import { Alert } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { TranslationNamespace } from 'i18n';
import { TraderActiveOrdersCount } from 'types';

type Props = {
  count?: TraderActiveOrdersCount;
};

export const TraderActiveOrdersAlert: React.FC<Props> = ({ count }) => {
  const { t } = useTranslation(TranslationNamespace.Common, {
    keyPrefix: 'components.trader_active_orders_alert',
  });

  if (!count || count.payin + count.payout === 0) {
    return null;
  }

  return (
    <Alert severity="warning" className="tw-mt-4">
      {t('description', { payin: count.payin, payout: count.payout })}
    </Alert>
  );
};
